[
  {
    "title": "Touren",
    "slug": "touren",
    "type": "tour",
    "categories": [
      {
        "title": "Wandern",
        "slug": "wandern",
        "ids": ["20777706"]
      },
      {
        "title": "Radfahren",
        "slug": "radfahren",
        "ids": ["20777711"]
      },
      {
        "title": "Stadtspaziergang",
        "slug": "stadtspaziergang",
        "ids": ["20777749", "20777726"]
      }
    ]
  },
  {
    "title": "Sehenswert",
    "slug": "sehenswert",
    "type": "poi",
    "categories": [
      {
        "title": "Bau- und Industriedenkmäler",
        "slug": "bau-industriedenkmale",
        "ids": [
          "20777951",
          "20777944",
          "20777948",
          "20777994",
          "20777940",
          "20777932",
          "20778064"
        ]
      },
      {
        "title": "Burgen & Schlösser",
        "slug": "burgen-schloesser",
        "ids": ["20777937", "20777962"]
      },
      {
        "title": "Kunst & Museen",
        "slug": "kunst-museen",
        "ids": ["20777955", "20777945", "20777938", "20777958"]
      },
      {
        "title": "Rathäuser",
        "slug": "rathaus",
        "ids": ["20778097"]
      },
      {
        "title": "Veranstaltungsorte & Cafés",
        "slug": "veranstaltungsorte-cafes",
        "ids": ["20777965", "20777943", "20777831"]
      }
    ]
  },
  {
    "title": "Sport + Gesundheit",
    "slug": "sport-gesundheit",
    "type": "poi",
    "categories": [
      {
        "title": "Bäder, Wellness & Kureinrichtungen",
        "slug": "bad-wellness-kur",
        "ids": ["20777898", "20777903", "20778030", "20777925"]
      },
      {
        "title": "Sportstätten & Reitsport",
        "slug": "sportstaetten-reitsport",
        "ids": ["20777878", "20777884", "20777849", "20777860", "20777876"]
      },
      {
        "title": "Hochseilgarten & Golf",
        "slug": "hochseil-golf",
        "ids": ["20777865", "20777911", "20777904"]
      },
      {
        "title": "Eissport",
        "slug": "eissport",
        "ids": ["20777858"]
      },
      {
        "title": "Angeln & Wassersport",
        "slug": "angeln-wassersport",
        "ids": ["20777892", "20777877", "42056926", "20777888", "20777847"]
      },
      {
        "title": "Motocross & Luftsport",
        "slug": "motocross-luftsport",
        "ids": ["20777872", "20777871"]
      }
    ]
  },
  {
    "title": "Unterkunft",
    "slug": "unterkunft",
    "type": "poi",
    "categories": [
      {
        "title": "Apartment",
        "slug": "apartment",
        "ids": ["20777775"]
      },
      {
        "title": "Hotel",
        "slug": "hotel",
        "ids": ["20777761"]
      },
      {
        "title": "Hotel Garni / Pension",
        "slug": "hotel-garni-pension",
        "ids": ["20777769", "20777772"]
      },
      {
        "title": "Privatzimmer",
        "slug": "privatzimmer",
        "ids": ["20777782"]
      },
      {
        "title": "Ferienwohnung / -haus",
        "slug": "ferienwohnung-haus",
        "ids": ["20777776", "20777779"]
      },
      {
        "title": "Reiterhof",
        "slug": "reiterhof",
        "ids": ["20777803"]
      },
      {
        "title": "Wohnmobilstellplatz",
        "slug": "wohnmobilstellplatz",
        "ids": ["20777812"]
      }
    ]
  },
  {
    "title": "Naturatlas",
    "slug": "naturatlas",
    "type": "poi",
    "ids": ["20777980"]
  },
  {
    "title": "Familie + Kinder",
    "slug": "familie-kinder",
    "type": "poi",
    "categories": [
      {
        "title": "Skate Park",
        "slug": "skate-park",
        "ids": ["20777878"]
      },
      {
        "title": "Eissport",
        "slug": "eissport",
        "ids": ["20777858"]
      },
      {
        "title": "Wassersport",
        "slug": "wassersport",
        "ids": ["20777892"]
      },
      {
        "title": "Bäder",
        "slug": "baeder",
        "ids": ["20777898", "20777903"]
      },
      {
        "title": "Minigolf",
        "slug": "minigolf",
        "ids": ["20777911"]
      },
      {
        "title": "Spielplatz",
        "slug": "spielplatz",
        "ids": ["20777921"]
      },
      {
        "title": "Kino",
        "slug": "kino",
        "ids": ["20777908"]
      },
      {
        "title": "Burg",
        "slug": "burg",
        "ids": ["20777937"]
      },
      {
        "title": "Museum",
        "slug": "museum",
        "ids": ["20777958"]
      },
      {
        "title": "Mühle",
        "slug": "mühle",
        "ids": ["20777994"]
      }
    ]
  }
]
